if (!customElements.get('mx-navigation-content')) {
  customElements.define('mx-navigation-content', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.drawer = this.closest('x-drawer');
      if (!this.drawer) return;
      this.header = this.header || this.closest('x-header');
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.panels = new Map([...this.querySelectorAll('[data-mx-nav-panel]')].map(panel => [panel.dataset.mxNavPanel, panel]));
      this.selectPanel(this.selected || 'all');
      document.addEventListener('click', event => this.onTrigger(event), {...options, capture: true});
      this.drawer.addEventListener('dialog:before-show', () => {this.updateTop(); this.syncControls();}, options);
      this.drawer.addEventListener('dialog:after-show', () => {this.updateTop(); this.syncControls();}, options);
      this.drawer.addEventListener('dialog:after-hide', () => this.syncControls(), options);
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-mx-localization-select]');
        if (select && !select.disabled && select.form) select.form.requestSubmit();
      }, options);
      window.addEventListener('resize', () => {if (this.drawer.open) this.updateTop();}, options);
      this.openNewsletterFeedback();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    onTrigger(event) {
      const trigger = event.target.closest('[data-mx-nav-target]');
      if (!trigger) return;
      const external = trigger.getAttribute('aria-controls') === this.drawer.id;
      if (!external && !this.contains(trigger)) return;
      const previous = this.selected;
      this.header = trigger.closest('x-header') || this.header;
      this.updateTop();
      this.selectPanel(trigger.dataset.mxNavTarget, this.drawer.open);
      if (!external) {
        event.preventDefault();
        return;
      }
      if (this.drawer.open && previous !== this.selected) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    selectPanel(target, focus = false) {
      const active = this.panels.get(target) || this.panels.get('all');
      if (!active) return;
      this.selected = active.dataset.mxNavPanel;
      this.panels.forEach(panel => {
        panel.hidden = panel !== active;
        panel.inert = panel !== active;
        const heading = panel.querySelector('.mx-navigation__panel-title');
        if (heading) heading.toggleAttribute('data-mx-nav-focus', panel === active);
      });
      const title = this.drawer.querySelector('[data-mx-nav-title]');
      if (title) title.textContent = active.dataset.mxNavLabel || title.dataset.mxNavDefaultTitle;
      const body = this.drawer.getShadowPartByName?.('body');
      if (body) body.scrollTop = 0;
      this.syncControls();
      if (focus) active.querySelector('.mx-navigation__panel-title')?.focus({preventScroll: true});
    }

    syncControls() {
      this.querySelectorAll('.mx-navigation__department').forEach(button => {
        button.setAttribute('aria-expanded', String(this.drawer.open && button.dataset.mxNavTarget === this.selected));
      });
      document.querySelectorAll(`[aria-controls="${CSS.escape(this.drawer.id)}"][data-mx-nav-target]`).forEach(button => {
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-expanded', String(this.drawer.open && (button.dataset.mxNavTarget === 'all' || button.dataset.mxNavTarget === this.selected)));
      });
    }

    updateTop() {
      const header = this.header?.isConnected ? this.header : document.querySelector('x-header');
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const height = window.visualViewport?.height || window.innerHeight;
      this.drawer.style.setProperty('--mx-nav-top', `${Math.min(bottom, Math.max(0, height - 120))}px`);
    }

    async openNewsletterFeedback() {
      if (this.feedbackHandled) return;
      const feedback = [...this.querySelectorAll('[data-mx-newsletter-feedback]')].find(item => item.dataset.mxNewsletterFeedback === this.drawer.id || item.dataset.mxDrawerId === this.drawer.id);
      const newsletterHash = `#mx-menu-newsletter-${this.dataset.mxNavInstance}`;
      if (window.location.hash !== newsletterHash) return;
      this.feedbackHandled = true;
      await customElements.whenDefined('x-drawer');
      if (!this.isConnected) return;
      this.selectPanel('all');
      this.updateTop();
      await this.drawer.show(false);
      const target = feedback || this.querySelector('.mx-navigation__newsletter');
      if (target) {
        target.tabIndex = -1;
        target.focus({preventScroll: true});
        target.scrollIntoView({block: 'nearest'});
      }
    }
  });
}
